<script>
import Loading from "../../../../common/loading.vue";
import DialogBase from "../../../../dialog/components/dialog-base.vue";
import DialogBody from "../../../../dialog/components/dialog-body.vue";
import DialogHeader from "../../../../dialog/components/dialog-header.vue";
import DialogActionbar from "../../../../dialog/components/dialog-actionbar.vue";
import {saveSettings, loadSettings} from "../calendarUtils";
import {DURATIONS, SETTING_FIELDS, SETTINGS, VIEWS} from "./calendarSettings";
import CalendarSettingsDialogField from "./calendar-settings-dialog-field.vue";

export default {
    name: "calendar-settings-dialog",
    components: {CalendarSettingsDialogField, DialogActionbar, DialogHeader, DialogBody, DialogBase, Loading},
    props: {
        showDialog: Boolean,
        /** @type {CalendarSettings} */
        defaultSettings: Object
    },
    data() {
        return {
            settings: {...SETTINGS}
        };
    },
    computed: {
        translations() {
            return {
                title: Lang.langGet('Calendar Settings'),
            }
        },
        fields() {
            return SETTING_FIELDS;
        },
    },
    methods: {
        handleClose(reload) {
            this.$emit('close', reload);
            this.loadSettings();
        },
        handleSave() {
            this.saveSettings();
            this.handleClose(true);
        },
        /**
         * Handles input changes and updates settings
         * @param {string} key - Setting property to update
         * @param {any} value - New value
         * @param {boolean} [saveImmediately=false] - Whether to save to localStorage
         */
        handleChange(key, value, saveImmediately = false) {
            if (!key || typeof key !== 'string') {
                console.error('Invalid settings key:', key);
                return;
            }

            const newSettings = { ...this.settings };
            newSettings[key] = value;
            this.settings = newSettings;

            if (saveImmediately) {
                this.saveSettings();
            }
        },

        saveSettings() {
            saveSettings(this.settings);
        },

        loadSettings() {
            this.settings = loadSettings(this.defaultSettings);
        }
    },
    mounted() {
        this.loadSettings();
    }
}
</script>

<template>
    <dialog-base v-if="showDialog"
        :maxWidth="480"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            class="text-truncate"
            @close="handleClose"
            :title="translations.title"
        />
        <dialog-body>
            <div class="calendar-settings-dialog-container">
                <calendar-settings-dialog-field :key="field.name" v-for="field in fields"
                    :value="settings[field.name]"
                    :definition="field"
                    @update:settings="handleChange"
                />
            </div>
        </dialog-body>
        <dialog-actionbar
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>

<style scoped>
    .calendar-settings-dialog-container {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        padding: 16px;
    }
</style>
